import { useMemo } from 'react';
import { useSelector } from 'react-redux';

const useUserDictionaryOptions = () => {
  const dictionary = useSelector((state) => state.dictionary);

  const prefixOptions = useMemo(() => dictionary?.codeNamePrefixes ?? [], [
    dictionary?.codeNamePrefixes,
  ]);
  const suffixOptions = useMemo(() => dictionary?.codeNameSuffixes ?? [], [
    dictionary?.codeNameSuffixes,
  ]);
  const raceOptions = useMemo(() => dictionary?.codeRace ?? [], [dictionary?.codeRace]);
  const sexOptions = useMemo(() => dictionary?.codeSex ?? [], [dictionary?.codeSex]);
  const ethnicityOptions = useMemo(() => dictionary?.codeEthnicity ?? [], [
    dictionary?.codeEthnicity,
  ]);
  const ageRangeOptions = useMemo(() => dictionary?.ageIncrement ?? [], [dictionary?.ageIncrement]);

  const eyeColorOptions = useMemo(() => dictionary?.codeEyeColor ?? [], [dictionary?.codeEyeColor]);
  const hairColorOptions = useMemo(() => dictionary?.codeHairColor ?? [], [
    dictionary?.codeHairColor,
  ]);
  const hairStyleOptions = useMemo(() => dictionary?.codeHairStyle ?? [], [
    dictionary?.codeHairStyle,
  ]);
  const hairLengthOptions = useMemo(() => dictionary?.codeHairLength ?? [], [
    dictionary?.codeHairLength,
  ]);
  const bloodTypeOptions = useMemo(() => dictionary?.codeBloodType ?? [], [
    dictionary?.codeBloodType,
  ]);
  const handedOptions = useMemo(() => dictionary?.codeHanded ?? [], [dictionary?.codeHanded]);
  const stateOptions = useMemo(() => dictionary?.codeStates ?? [], [dictionary?.codeStates]);
  const streetDirectionOptions = useMemo(() => dictionary?.codeStreetDirections ?? [], [
    dictionary?.codeStreetDirections,
  ]);
  const streetTypeOptions = useMemo(() => dictionary?.codeStreetTypes ?? [], [
    dictionary?.codeStreetTypes,
  ]);
  const cityOptions = useMemo(() => {
    return (dictionary?.codeCities ?? []).map((item) => ({
      ...item,
      Code: item.ptsCityID,
      Description: item.CityDescription,
    }));
  }, [dictionary?.codeCities]);

  const countyOptions = useMemo(() => dictionary?.codeCounties ?? [], [dictionary?.codeCounties]);
  const countryOptions = useMemo(() => dictionary?.codeCountries ?? [], [
    dictionary?.codeCountries,
  ]);
  const deathCauseOptions = useMemo(() => dictionary?.codeDeathCauses ?? [], [
    dictionary?.codeDeathCauses,
  ]);
  const residentOptions = useMemo(() => dictionary?.codeResident ?? [], [dictionary?.codeResident]);
  const citizenshipOptions = useMemo(() => dictionary?.codeCitizenships ?? [], [
    dictionary?.codeCitizenships,
  ]);
  const nationalityOptions = useMemo(() => dictionary?.codeNationalities ?? [], [
    dictionary?.codeNationalities,
  ]);
  const gangOptions = useMemo(() => dictionary?.codeGang ?? [], [dictionary?.codeGang]);
  const maritalStatusOptions = useMemo(() => dictionary?.codeMaritalStatus ?? [], [
    dictionary?.codeMaritalStatus,
  ]);
  const languageOptions = useMemo(() => dictionary?.codeLanguages ?? [], [
    dictionary?.codeLanguages,
  ]);
  const dangerousTypeOptions = useMemo(() => dictionary?.codeDangerousType ?? [], [
    dictionary?.codeDangerousType,
  ]);
  const contactTypeOptions = useMemo(() => dictionary?.codeContactInfoMethodTypes ?? [], [
    dictionary?.codeContactInfoMethodTypes,
  ]);
  const unitTypeOptions = useMemo(() => dictionary?.codeAddressUnitTypes ?? [], [
    dictionary?.codeAddressUnitTypes,
  ]);
  const addressCategoryOptions = useMemo(() => dictionary?.codeAddressCategories ?? [], [
    dictionary?.codeAddressCategories,
  ]);
  const floorTypeOptions = useMemo(() => dictionary?.codeAddressFloorTypes ?? [], [
    dictionary?.codeAddressFloorTypes,
  ]);
  const bldgTypeOptions = useMemo(() => dictionary?.codeAddressBldgTypes ?? [], [
    dictionary?.codeAddressBldgTypes,
  ]);
  const esnOptions = useMemo(() => dictionary?.cadESNs ?? [], [dictionary?.cadESNs]);
  const nameTypeOptions = useMemo(() => dictionary?.codePersonNameTypes ?? [], [
    dictionary?.codePersonNameTypes,
  ]);
  const contactMethodOptions = useMemo(() => dictionary?.ContactMethods ?? [], [
    dictionary?.ContactMethods,
  ]);
  const credentialTypeOptions = useMemo(() => dictionary?.codeCredentialTypes ?? [], [
    dictionary?.codeCredentialTypes,
  ]);
  const credentialClassOptions = useMemo(() => dictionary?.codeCredentialClasses ?? [], [
    dictionary?.codeCredentialClasses,
  ]);
  const positionOptions = useMemo(() => dictionary?.codePositions ?? [], [
    dictionary?.codePositions,
  ]);
  const occupationOptions = useMemo(() => dictionary?.codeOccupations ?? [], [
    dictionary?.codeOccupations,
  ]);
  const rankOptions = useMemo(() => dictionary?.codeRanks ?? [], [dictionary?.codeRanks]);
  const employmentStatusOptions = useMemo(() => dictionary?.codeEmploymentStatuses ?? [], [
    dictionary?.codeEmploymentStatuses,
  ]);
  const payRateOptions = useMemo(() => dictionary?.PayRates ?? [], [dictionary?.PayRates]);
  const terminationReasonOptions = useMemo(() => dictionary?.codeTerminationReasons ?? [], [
    dictionary?.codeTerminationReasons,
  ]);
  const dnaSampleTypeOptions = useMemo(() => dictionary?.codeDNASampleType ?? [], [
    dictionary?.codeDNASampleType,
  ]);
  const dnaSampleMethodOptions = useMemo(() => dictionary?.codeDNASampleMethod ?? [], [
    dictionary?.codeDNASampleMethod,
  ]);
  const dnaSampleReasonOptions = useMemo(() => dictionary?.codeDNASampleReason ?? [], [
    dictionary?.codeDNASampleReason,
  ]);
  const dnaCollectionStatusOptions = useMemo(() => dictionary?.codeDNACollection ?? [], [
    dictionary?.codeDNACollection,
  ]);
  const associateRelationshipOptions = useMemo(() => dictionary?.codeAssociateRelationships ?? [], [
    dictionary?.codeAssociateRelationships,
  ]);
  const partyKindOptions = useMemo(() => dictionary?.PartyTypes ?? [], [dictionary?.PartyTypes]);
  const plateTypeOptions = useMemo(() => dictionary?.codePlateTypes ?? [], [
    dictionary?.codePlateTypes,
  ]);
  const plateColorOptions = useMemo(() => dictionary?.codePlateColors ?? [], [
    dictionary?.codePlateColors,
  ]);
  const plateStatusOptions = useMemo(() => dictionary?.codePlateStatuses ?? [], [
    dictionary?.codePlateStatuses,
  ]);
  const plateDetailOptions = useMemo(() => dictionary?.codePlateDetails ?? [], [
    dictionary?.codePlateDetails,
  ]);
  const tagTypeOptions = useMemo(() => dictionary?.codeTagTypes ?? [], [dictionary?.codeTagTypes]);

  const placeTypeOptions = useMemo(() => dictionary?.codePlaceTypes ?? [], [
    dictionary?.codePlaceTypes,
  ]);

  const vehicleMakeOptions = useMemo(() => dictionary?.codeVehicleMakes ?? [], [
    dictionary?.codeVehicleMakes,
  ]);
  const vehicleMakesModelsOptions = useMemo(() => dictionary?.codeVehicleMakesModels ?? [], [
    dictionary?.codeVehicleMakesModels,
  ]);
  const vehicleStyleOptions = useMemo(() => dictionary?.codeVehicleStyles ?? [], [
    dictionary?.codeVehicleStyles,
  ]);
  const vehicleColorOptions = useMemo(() => dictionary?.codeVehicleColors ?? [], [
    dictionary?.codeVehicleColors,
  ]);
  const vehicleClassificationOptions = useMemo(() => dictionary?.codeVehicleClassifications ?? [], [
    dictionary?.codeVehicleClassifications,
  ]);
  const vehicleBrandOptions = useMemo(() => dictionary?.codeVehicleBrands ?? [], [
    dictionary?.codeVehicleBrands,
  ]);
  const vehicleBranderOptions = useMemo(() => dictionary?.codeVehicleBranders ?? [], [
    dictionary?.codeVehicleBranders,
  ]);
  const vehiclePropertyOptions = useMemo(() => dictionary?.codeVehicleProperty ?? [], [
    dictionary?.codeVehicleProperty,
  ]);
  const vehicleCommercialOptions = useMemo(() => dictionary?.codeVehicleCommercial ?? [], [
    dictionary?.codeVehicleCommercial,
  ]);
  const transmissionOptions = useMemo(() => dictionary?.codeTransmissions ?? [], [
    dictionary?.codeTransmissions,
  ]);
  const garageFacilityOptions = useMemo(() => dictionary?.codeGarageFacilities ?? [], [
    dictionary?.codeGarageFacilities,
  ]);

  const attachmentTypeOptions = useMemo(() => dictionary?.codeAttachmentTypes ?? [], [
    dictionary?.codeAttachmentTypes,
  ]);

  const measureOptions = useMemo(() => dictionary?.codeMeasures ?? [], [dictionary?.codeMeasures]);
  const addressPartyRelationshipOptions = useMemo(
    () => dictionary?.codeAddressPartyRelationship ?? [],
    [dictionary?.codeAddressPartyRelationship]
  );
  const prePlanOccupancyTypeOptions = useMemo(() => dictionary?.codePrePlanOccupancyTypes ?? [], [
    dictionary?.codePrePlanOccupancyTypes,
  ]);
  const prePlanConstructionTypeOptions = useMemo(
    () => dictionary?.codePrePlanConstructionTypes ?? [],
    [dictionary?.codePrePlanConstructionTypes]
  );
  const prePlanRoofTypeOptions = useMemo(() => dictionary?.codePrePlanRoofTypes ?? [], [
    dictionary?.codePrePlanRoofTypes,
  ]);
  const designationOptions = useMemo(() => dictionary?.codeDesignation ?? [], [
    dictionary?.codeDesignation,
  ]);

  const mugshotTypeOptions = useMemo(() => dictionary?.codeMugshotTypes ?? [], [
    dictionary?.codeMugshotTypes,
  ]);
  const markTypeOptions = useMemo(() => dictionary?.codeMarks ?? [], [dictionary?.codeMarks]);
  const markLocationOptions = useMemo(() => dictionary?.codeMarkLocation ?? [], [
    dictionary?.codeMarkLocation,
  ]);

  const alertTypeOptions = useMemo(() => dictionary?.AlertTypes ?? [], [dictionary?.AlertTypes]);
  const agencyOptions = useMemo(() => dictionary?.Agencies ?? [], [dictionary?.Agencies]);

  return useMemo(
    () => ({
      dictionary,
      prefixOptions,
      suffixOptions,
      raceOptions,
      sexOptions,
      ethnicityOptions,
      ageRangeOptions,
      eyeColorOptions,
      hairColorOptions,
      hairStyleOptions,
      hairLengthOptions,
      bloodTypeOptions,
      handedOptions,
      stateOptions,
      streetDirectionOptions,
      streetTypeOptions,
      cityOptions,
      countyOptions,
      countryOptions,
      deathCauseOptions,
      residentOptions,
      citizenshipOptions,
      nationalityOptions,
      gangOptions,
      maritalStatusOptions,
      languageOptions,
      dangerousTypeOptions,
      contactTypeOptions,
      unitTypeOptions,
      addressCategoryOptions,
      floorTypeOptions,
      bldgTypeOptions,
      esnOptions,
      nameTypeOptions,
      contactMethodOptions,
      credentialTypeOptions,
      credentialClassOptions,
      positionOptions,
      occupationOptions,
      rankOptions,
      employmentStatusOptions,
      payRateOptions,
      terminationReasonOptions,
      dnaSampleTypeOptions,
      dnaSampleMethodOptions,
      dnaSampleReasonOptions,
      dnaCollectionStatusOptions,
      associateRelationshipOptions,
      partyKindOptions,
      plateTypeOptions,
      plateColorOptions,
      plateStatusOptions,
      plateDetailOptions,
      tagTypeOptions,
      attachmentTypeOptions,
      mugshotTypeOptions,
      markTypeOptions,
      markLocationOptions,
      alertTypeOptions,
      agencyOptions,
      placeTypeOptions,
      vehicleMakeOptions,
      vehicleMakesModelsOptions,
      vehicleStyleOptions,
      vehicleColorOptions,
      vehicleClassificationOptions,
      vehicleBrandOptions,
      vehicleBranderOptions,
      vehiclePropertyOptions,
      vehicleCommercialOptions,
      transmissionOptions,
      garageFacilityOptions,
      measureOptions,
      addressPartyRelationshipOptions,
      prePlanOccupancyTypeOptions,
      prePlanConstructionTypeOptions,
      prePlanRoofTypeOptions,
      designationOptions,
    }),
    [
      dictionary,
      prefixOptions,
      suffixOptions,
      raceOptions,
      sexOptions,
      ethnicityOptions,
      ageRangeOptions,
      eyeColorOptions,
      hairColorOptions,
      hairStyleOptions,
      hairLengthOptions,
      bloodTypeOptions,
      handedOptions,
      stateOptions,
      streetDirectionOptions,
      streetTypeOptions,
      cityOptions,
      countyOptions,
      countryOptions,
      deathCauseOptions,
      residentOptions,
      citizenshipOptions,
      nationalityOptions,
      gangOptions,
      maritalStatusOptions,
      languageOptions,
      dangerousTypeOptions,
      contactTypeOptions,
      unitTypeOptions,
      addressCategoryOptions,
      floorTypeOptions,
      bldgTypeOptions,
      esnOptions,
      nameTypeOptions,
      contactMethodOptions,
      credentialTypeOptions,
      credentialClassOptions,
      positionOptions,
      occupationOptions,
      rankOptions,
      employmentStatusOptions,
      payRateOptions,
      terminationReasonOptions,
      dnaSampleTypeOptions,
      dnaSampleMethodOptions,
      dnaSampleReasonOptions,
      dnaCollectionStatusOptions,
      associateRelationshipOptions,
      partyKindOptions,
      plateTypeOptions,
      plateColorOptions,
      plateStatusOptions,
      plateDetailOptions,
      tagTypeOptions,
      attachmentTypeOptions,
      mugshotTypeOptions,
      markTypeOptions,
      markLocationOptions,
      alertTypeOptions,
      agencyOptions,
      placeTypeOptions,
      vehicleMakeOptions,
      vehicleMakesModelsOptions,
      vehicleStyleOptions,
      vehicleColorOptions,
      vehicleClassificationOptions,
      vehicleBrandOptions,
      vehicleBranderOptions,
      vehiclePropertyOptions,
      vehicleCommercialOptions,
      transmissionOptions,
      garageFacilityOptions,
      measureOptions,
      addressPartyRelationshipOptions,
      prePlanOccupancyTypeOptions,
      prePlanConstructionTypeOptions,
      prePlanRoofTypeOptions,
      designationOptions,
    ]
  );
};

export default useUserDictionaryOptions;
